import Vue from 'vue'

export const state = Vue.observable({
  results: [],
  total: 0,
  pagination: {},
  filters: {},
  resultsSpecialRequests: [],
  totalSpecialRequests: 0,
  paginationSpecialRequests: {},
  filtersSpecialRequests: {}
})


export const mutations = {
  setResults: results => {
    state.results = results
  },
  setTotalResults: total => {
    state.total = total
  },
  setPagination: pagination => {
    state.pagination = pagination
  },
  setFilters: filters => {
    state.filters = filters
  },

  setResultsSpecialRequests: results => {
    state.resultsSpecialRequests = results
  },
  setTotalResultsSpecialRequests: total => {
    state.totalSpecialRequests = total
  },
  setPaginationSpecialRequests: pagination => {
    state.paginationSpecialRequests = pagination
  },
  setFiltersSpecialRequests: filters => {
    state.filtersSpecialRequests = filters
  }
}
